import React from 'react';
import { Box, Divider } from '@chakra-ui/react';
import type { TransferDirection } from 'antd/es/transfer';
import DynamicQuestion from '../DynamicQuestion/DynamicQuestion';

interface SectionComponentProps {
  sectionList: {
    items: Array<any>;
  };
  control: any;
  validateInputs: (value: any) => boolean | string;
  getValues: (name?: string) => any;
  validateSubQuestion: (isTrue: boolean, items: any, values: any) => void;
  targetKeys?: string[];
  selectedKeys?: string[];
  onChange?: (
    nextTargetKeys: string[],
    direction: TransferDirection,
    moveKeys: string[],
    questionCode: string,
  ) => void;
  onSelectChange?: (
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[],
  ) => void;
  onScroll?: (
    direction: TransferDirection,
    e: React.SyntheticEvent<HTMLUListElement>,
  ) => void;
  errors: any;
  handleDataChange?: (data: any) => void;
  dataListChange?: any[];
}

const divider = (item: any) => {

  return (<>
  {item.parentType === 'PARENT' && item.type !== 'Label' &&  <Divider mb={5} mt={5} />}
  </>)
}

const SectionComponent: React.FC<SectionComponentProps> = ({
  sectionList,
  control,
  validateInputs,
  getValues,
  validateSubQuestion,
  targetKeys,
  selectedKeys,
  onChange,
  onSelectChange,
  onScroll,
  errors,
  handleDataChange,
  dataListChange
}) => {
  return (
    <Box>
      {sectionList.items.map(questionList => (
        < React.Fragment key={`${questionList.value}-${questionList.type}`}>
        
          <DynamicQuestion
            key={questionList.value}
            sectionList={sectionList}
            questionList={questionList}
            control={control}
            validateInputs={validateInputs}
            getValues={getValues}
            validateSubQuestion={validateSubQuestion}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onChange}
            onSelectChange={onSelectChange}
            onScroll={onScroll}
            errors={errors}
            handleDataChange={handleDataChange}
            dataListChange={dataListChange}

          />
          {divider(questionList)}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default SectionComponent;
